import { SectionStateType, TabSections, TabSectionType } from '../types';

/**
 * The default state of each section.
 * loading is set to true by default.
 * So, that sections can fetch new data on load/change
 */
const defaultSectionState: SectionStateType = {
  loading: true,
  error: false,
};

/**
 * Generates a state object for each section
 * {
 *  [section_name]: { loading: true, error: false}
 *  ...
 * }
 */
export const generateSectionState = (sections: TabSections[]): TabSectionType<TabSections> =>
  sections.reduce((acc, section) => ({ ...acc, [section]: defaultSectionState }), {});
